import hash from 'object-hash';

import { cacheRequest, cacheResponse } from 'utility/Request/cache';
import { callApi } from 'utility/Request/callApi';

import { ApiEndpoint } from 'types/Request/endpoint';

import { RequestFilterGroup } from 'proto/Search/KiFilter/RequestFilterGroup';

export const fetchFilterDataPromptCached = cacheRequest(
    cacheResponse(async (requestFilterGroupList: RequestFilterGroup[]) => {
        try {
            const response = await callApi(ApiEndpoint.FilterDataPrompt, {
                requestData: {
                    filterData: requestFilterGroupList,
                },
            });

            return (
                response.parsedBody ?? { status: 'error', filterDataPrompt: '' }
            );
        } catch (e) {
            throw new Error(`Error fetching filter data: ${e}`);
        }
    }, hash),
    hash
);
